<template>
  <div id="users_detail">
    <Navbar
      current="Detalhes do psicólogo"
      :link="$paths.psychologists.list"
      :linkName="'Psicólogos'"
    />
    <Sidebar />
    <Container col="12">
      <Header title="Detalhes do Psi" v-if="!loadingItems">
        <template v-slot:button>
          <button
            v-if="!item.deleted_at"
            @click="showResetPasswordModal = true"
            class="btn btn-outline-secondary"
          >
            <i class="fa-solid fa-key"></i> Gerar link de senha
          </button>
          <button
            v-if="item.deleted_at"
            @click="showReactivateModal = true"
            class="btn btn-success ms-3"
          >
            <i class="fa-solid fa-rotate-left"></i> Reativar conta
          </button>
          <div v-if="!item.deleted_at" class="d-inline">
            <button
              @click="changeCRPPhotosClicked()"
              class="btn btn-outline-secondary ms-3"
            >
              <i class="fa-solid fa-id-card"></i> Editar fotos CRP
            </button>

            <button
              v-if="!item?.block_agenda"
              @click="handleChangeAgenda()"
              class="btn btn-outline-secondary ms-3"
            >
              <i class="fa-solid fa-calendar-xmark"></i>
              Bloquear agenda
            </button>
            <button
              v-else
              @click="handleChangeAgenda()"
              class="btn btn-outline-secondary ms-3"
            >
              <i class="fa-solid fa-calendar-check"></i>
              Desbloquear agenda
            </button>
            <button
              v-if="item.active"
              @click="handleChangeActive()"
              class="btn btn-outline-secondary ms-3"
            >
              <i class="fa-solid fa-lock"></i>
              Desativar
            </button>
            <button
              v-else
              @click="handleChangeActive()"
              class="btn btn-light ms-3"
            >
              <i class="fa-solid fa-lock-open"></i>
              Ativar
            </button>
            <button
              v-if="item.approved"
              @click="handleChangeApprove()"
              class="btn btn-outline-danger ms-3"
            >
              <span
                v-if="isApproving"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              <i class="fa-solid fa-ban" v-else></i>
              Desaprovar
            </button>
            <button
              v-else
              @click="handleChangeApprove()"
              class="btn btn-success ms-3"
            >
              <span
                v-if="isApproving"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              <i class="fa-solid fa-circle-check" v-else></i>
              Aprovar
            </button>
          </div>
          <router-link
            v-if="!item.deleted_at"
            :to="`${$paths.psychologists.edit}/${item.id}`"
            class="btn btn-primary lift ms-5"
          >
            <i class="fa-solid fa-pen me-1"></i> Editar
          </router-link>
        </template>
      </Header>

      <LoadingContainer v-if="loadingItems" />

      <div v-else>
        <div class="row">
          <div :class="showSummary ? 'col-12 col-xl-8' : 'col-12'">
            <div class="card">
              <div class="d-flex align-items-center">
                <ul class="nav nav-tabs ps-4 pt-3 flex-grow-1" id="myTab" role="tablist">
                <li class="nav-item active" role="presentation">
                  <button
                    class="nav-link active"
                    id="account-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#account"
                    type="button"
                    role="tab"
                    aria-controls="account"
                    aria-selected="true"
                    @click="showSummary = true"
                  >
                    Cadastro
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="profile-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#profile"
                    type="button"
                    role="tab"
                    aria-controls="profile"
                    aria-selected="false"
                    @click="showSummary = true"
                  >
                    Perfil
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="schedule-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#schedule"
                    type="button"
                    role="tab"
                    aria-controls="schedule"
                    aria-selected="false"
                    @click="showSummary = true"
                  >
                    Horários
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="bank-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#bank"
                    type="button"
                    role="tab"
                    aria-controls="bank"
                    aria-selected="false"
                    @click="showSummary = true"
                  >
                    Dados bancários
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="appointments-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#appointments"
                    type="button"
                    role="tab"
                    aria-controls="appointments"
                    aria-selected="false"
                    @click="showSummary = false; loadAppointmentsTab()"
                  >
                    Sessões
                    <span
                      class="badge bg-primary-soft"
                      style="font-size: 0.8rem"
                      >{{ item.appointments_count }}</span
                    >
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="transfer-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#transfer"
                    type="button"
                    role="tab"
                    aria-controls="transfer"
                    aria-selected="false"
                    @click="showSummary = false"
                  >
                    Repasses
                    <span
                      class="badge bg-primary-soft"
                      style="font-size: 0.8rem"
                      >{{ item.payouts?.length }}</span
                    >
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="review-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#review"
                    type="button"
                    role="tab"
                    aria-controls="review"
                    aria-selected="false"
                    @click="showSummary = false"
                  >
                    Avaliações
                    <span
                      class="badge bg-primary-soft"
                      style="font-size: 0.8rem"
                      >{{ item.latest_ratings?.length }}</span
                    >
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="coupons-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#coupons"
                    type="button"
                    role="tab"
                    aria-controls="coupons"
                    aria-selected="false"
                    @click="showSummary = false"
                  >
                    Cupons
                    <span
                      class="badge bg-primary-soft"
                      style="font-size: 0.8rem"
                      >{{ item.coupons?.length }}</span
                    >
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="subscriptions-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#subscriptions"
                    type="button"
                    role="tab"
                    aria-controls="subscriptions"
                    aria-selected="false"
                    @click="showSummary = false; loadSubscriptionsTab()"
                  >
                    Assinaturas
                    <span
                      class="badge bg-primary-soft"
                      style="font-size: 0.8rem"
                      >{{ item.subscriptions?.length }}</span
                    >
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="connect-accounts-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#connect-accounts"
                    type="button"
                    role="tab"
                    aria-controls="connect-accounts"
                    aria-selected="false"
                    @click="showSummary = false; loadConnectAccountsTab()"
                  >
                    Contas Stripe Connect
                    <span
                      v-if="item.connect_accounts_count"
                      class="badge bg-primary-soft"
                      style="font-size: 0.8rem"
                      >{{ item.connect_accounts_count }}</span
                    >
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="change-logs-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#change-logs"
                    type="button"
                    role="tab"
                    aria-controls="change-logs"
                    aria-selected="false"
                    @click="showSummary = false; loadChangeLogsTab()"
                  >
                    Histórico de Alterações
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="admin-logs-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#admin-logs"
                    type="button"
                    role="tab"
                    aria-controls="admin-logs"
                    aria-selected="false"
                    @click="showSummary = false; loadAdminLogsTab()"
                  >
                    Logs de Admin
                  </button>
                </li>
                </ul>
                <button
                  v-if="!showSummary"
                  @click="showSummary = true"
                  class="btn btn-sm btn-outline-secondary me-3 mt-2"
                  title="Mostrar painel lateral"
                  style="white-space: nowrap"
                >
                  <i class="fa-solid fa-angles-right me-1"></i> Ver painel
                </button>
              </div>
              <div class="tab-content" id="myTabContent">
                <!-- Account Tab -->
                <div
                  class="tab-pane card-body fade show active"
                  id="account"
                  role="tabpanel"
                  aria-labelledby="account-tab"
                >
                  <PsiDetailRegisterInfo
                    :item="item"
                    @changeCallProvider="changeCallProvider"
                  />
                </div>

                <!-- Profile Tab -->
                <div
                  class="tab-pane card-body fade"
                  id="profile"
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                >
                  <PsiDetailProfile :item="item" />
                </div>

                <!-- Schedule Tab -->
                <div
                  class="tab-pane fade"
                  id="schedule"
                  role="tabpanel"
                  aria-labelledby="schedule-tab"
                >
                  <PsiDetailSchedules :item="item" />
                </div>

                <!-- Bank Tab -->
                <div
                  class="tab-pane card-body fade"
                  id="bank"
                  role="tabpanel"
                  aria-labelledby="bank-tab"
                >
                  <PsiDetailBankInfo :item="item" @accountCreated="getData" />
                </div>

                <!-- Appointments Tab -->
                <div
                  class="tab-pane fade"
                  id="appointments"
                  role="tabpanel"
                  aria-labelledby="appointments-tab"
                >
                  <PsiDetailAppointments
                    v-if="appointmentsLoaded"
                    :item="item"
                    ref="appointmentsComponent"
                  />
                </div>

                <!-- Transfer Tab -->
                <div
                  class="tab-pane fade"
                  id="transfer"
                  role="tabpanel"
                  aria-labelledby="transfer-tab"
                >
                  <PsiDetailPayouts :item="item" />
                </div>

                <!-- Review Tab -->
                <div
                  class="tab-pane card-body fade"
                  id="review"
                  role="tabpanel"
                  aria-labelledby="review-tab"
                >
                  <PsiDetailRatings :item="item" />
                </div>

                <!-- Coupons Tab -->
                <div
                  class="tab-pane card-body fade"
                  id="coupons"
                  role="tabpanel"
                  aria-labelledby="review-tab"
                >
                  <PsiDetailCoupons :item="item" />
                </div>

                <!-- Subscriptions Tab -->
                <div
                  class="tab-pane fade"
                  id="subscriptions"
                  role="tabpanel"
                  aria-labelledby="review-tab"
                >
                  <PsiDetailSubscriptions :item="item" @refresh="getData" />
                </div>

                <!-- Connect Accounts Tab -->
                <div
                  class="tab-pane fade"
                  id="connect-accounts"
                  role="tabpanel"
                  aria-labelledby="connect-accounts-tab"
                >
                  <PsiDetailConnectAccounts
                    v-if="connectAccountsLoaded"
                    :item="item"
                    ref="connectAccountsComponent"
                  />
                </div>

                <!-- Change Logs Tab -->
                <div
                  class="tab-pane card-body fade"
                  id="change-logs"
                  role="tabpanel"
                  aria-labelledby="change-logs-tab"
                >
                  <UserChangeLogsTab
                    v-if="changeLogsLoaded"
                    :userId="item.id"
                  />
                </div>

                <!-- Admin Logs Tab -->
                <div
                  class="tab-pane card-body fade"
                  id="admin-logs"
                  role="tabpanel"
                  aria-labelledby="admin-logs-tab"
                >
                  <AdminActionLogsList
                    v-if="adminLogsLoaded"
                    :baseFilters="{ target_type: 'psychologist', target_id: item.id }"
                    :hideTargetFilter="true"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- STICKY CARD -->
          <transition name="slide-panel">
            <div class="col-12 col-xl-4" v-show="showSummary">
              <PsiDetailSummary :item="item" @hide="showSummary = false" />
            </div>
          </transition>
        </div>
      </div>
    </Container>
    <ModalComponent :title="'Alterar email'" id="changeEmailModal">
      <template v-slot:body>
        <div class="mt-3">
          <TextInput
            label=""
            :model="$v.form.email"
            class="text-white"
            placeholder="Confirme a senha"
          />
          <p v-if="$v.form.email.$invalid" class="text-danger">
            * Email inválido
          </p>
          <p class="text-center text-danger">
            {{ errorMessage }}
          </p>
        </div>
      </template>
      <template v-slot:footer>
        <div>
          <FormButton
            label="Concluir"
            :loading="submitting"
            :disabled="$v.form.$invalid"
            class="btn w-15 btn-primary mb-3"
            @onClick="handleChangeEmail"
          />
        </div>
      </template>
    </ModalComponent>

    <ModalComponent :title="'Alterar fotos do CRP'" id="changeCRPPhotosModal">
      <template v-slot:body>
        <div class="mt-3">
          <label class="text-muted mb-3 mt-3 form-label"
            >Foto do CRP <i class="text-danger">*</i></label
          >
          <input
            type="file"
            class="form-control"
            accept="image/*,application/pdf"
            @change="handleDocumentImageChange"
          />
          <div v-if="documentImagePreview" class="mt-3">
            <iframe
              v-if="documentImagePreview.isPdf"
              :src="documentImagePreview.url"
              class="w-100 border rounded"
              style="height: 300px"
            ></iframe>
            <img
              v-else
              :src="documentImagePreview.url"
              class="img-fluid rounded border"
              style="max-height: 300px"
            />
          </div>
          <p
            v-if="$v.changeCRPPhotosForm.document_image.$invalid"
            class="text-danger mt-2"
          >
            * Selecione uma foto ou PDF do CRP
          </p>

          <label class="text-muted mb-3 mt-4 form-label"
            >Foto psi segurando o CRP <i class="text-danger">*</i></label
          >
          <input
            type="file"
            class="form-control"
            accept="image/*,application/pdf"
            @change="handleDocumentInHandChange"
          />
          <div v-if="documentInHandPreview" class="mt-3">
            <iframe
              v-if="documentInHandPreview.isPdf"
              :src="documentInHandPreview.url"
              class="w-100 border rounded"
              style="height: 300px"
            ></iframe>
            <img
              v-else
              :src="documentInHandPreview.url"
              class="img-fluid rounded border"
              style="max-height: 300px"
            />
          </div>
          <p
            v-if="$v.changeCRPPhotosForm.document_in_hand.$invalid"
            class="text-danger mt-2"
          >
            * Selecione uma foto ou PDF do psi segurando CRP
          </p>
        </div>
      </template>
      <template v-slot:footer>
        <div>
          <FormButton
            label="Concluir alteração"
            :loading="submitting"
            :disabled="$v.$invalid"
            class="btn w-15 btn-primary mb-3"
            @onClick="handlechangeCRPPhotos"
          />
        </div>
      </template>
    </ModalComponent>

    <!-- Modal Reativar Conta -->
    <div
      class="modal fade"
      :class="{ show: showReactivateModal }"
      :style="{ display: showReactivateModal ? 'block' : 'none' }"
      tabindex="-1"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="fa-solid fa-rotate-left me-2"></i>
              Reativar conta excluída
            </h5>
            <button type="button" class="btn-close" @click="closeReactivateModal"></button>
          </div>
          <div class="modal-body">
            <div class="alert alert-warning">
              <strong>Atenção!</strong> Esta conta foi excluída anteriormente.
            </div>
            <p>Ao reativar esta conta, o usuário poderá acessar o aplicativo novamente com as mesmas credenciais.</p>
            <div class="form-check mt-4">
              <input
                class="form-check-input"
                type="checkbox"
                id="confirmReactivateCheckbox"
                v-model="confirmReactivate"
              />
              <label class="form-check-label" for="confirmReactivateCheckbox">
                <strong>Eu confirmo</strong> que desejo reativar esta conta
              </label>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeReactivateModal">Cancelar</button>
            <button
              type="button"
              class="btn btn-success"
              :disabled="!confirmReactivate || reactivating"
              @click="handleReactivateAccount"
            >
              <span v-if="reactivating" class="spinner-border spinner-border-sm me-1"></span>
              Reativar conta
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showReactivateModal" class="modal-backdrop fade show"></div>

    <!-- Modal Gerar Link Reset Senha -->
    <div
      class="modal fade"
      :class="{ show: showResetPasswordModal }"
      :style="{ display: showResetPasswordModal ? 'block' : 'none' }"
      tabindex="-1"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="fa-solid fa-key me-2"></i>
              Gerar link de redefinição de senha
            </h5>
            <button type="button" class="btn-close" @click="closeResetPasswordModal"></button>
          </div>
          <div class="modal-body">
            <div v-if="!resetPasswordLink">
              <p>Será gerado um link para o usuário redefinir sua senha. Você poderá copiar e enviar para ele.</p>
              <button
                class="btn btn-primary w-100"
                :disabled="generatingResetLink"
                @click="handleGenerateResetLink"
              >
                <span v-if="generatingResetLink" class="spinner-border spinner-border-sm me-1"></span>
                Gerar link
              </button>
            </div>
            <div v-else>
              <div class="alert alert-success">
                <i class="fa-solid fa-check-circle me-1"></i>
                Link gerado com sucesso!
              </div>
              <label class="form-label text-muted">Link de redefinição:</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  :value="resetPasswordLink"
                  readonly
                />
                <button class="btn btn-outline-secondary" @click="copyResetLink">
                  <i class="fa-solid fa-copy"></i>
                </button>
              </div>
              <small class="text-muted">Copie e envie este link para o usuário</small>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeResetPasswordModal">Fechar</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showResetPasswordModal" class="modal-backdrop fade show"></div>
  </div>
</template>
<script>
import PsychologistDetailController from "./PsychologistDetailController";
export default PsychologistDetailController;
</script>
<style scoped>
.slide-panel-enter-active,
.slide-panel-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
  overflow: hidden;
}
.slide-panel-enter,
.slide-panel-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
